// extracted by mini-css-extract-plugin
export default {"Options":"RemoveLawListModal_Options__iLn5M"};